import React, { Component, Fragment } from 'react';
import { Formik, Form, Field, FieldArray } from 'formik';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import { useMutation } from 'react-apollo-hooks';
import { Query, Mutation } from 'react-apollo';
import gql from 'graphql-tag';
import classNames from 'classnames';
import Select from 'react-select';
import Textarea from 'react-autosize-textarea';

const TAGS_QUERY = gql`
  query {
    tags {
      id
      name
      qaCount
    }
  }
`;

const TAG_QUERY = gql`
  query tag($id: Int!) {
    tag(id: $id) {
      id
      name
      qaCount
    }
  }
`;

const EDIT_TAG_MUTATION = gql`
  mutation editTag($id: Int!, $name: String!) {
    editTag(id: $id, name: $name)
  }
`;

const DELETE_TAG_MUTATION = gql`
  mutation deleteTag($id: Int!) {
    deleteTag(id: $id)
  }
`;

class EditTagModal extends Component {
  scrollable = React.createRef();

  state = {
    removeConfirm: false
  };

  showConfirm = e => {
    e.preventDefault();

    this.setState({
      removeConfirm: true
    });
  };

  hideConfirm = e => {
    e.preventDefault();

    this.setState({
      removeConfirm: false
    });
  };

  componentDidMount() {
    disableBodyScroll(this.scrollable.current);
  }

  componentWillUnmount() {
    clearAllBodyScrollLocks();
  }

  render() {
    const { id, closeModal } = this.props;

    return (
      <Fragment>
        <div className="modal-header">
          <div className="modal-header-title">Muokkaa Tagia</div>
          <div className="modal-header-close" onClick={closeModal}>
            Sulje
          </div>
        </div>
        <Query query={TAG_QUERY} variables={{ id }}>
          {({ loading: tagLoading, error: tagError, data }) => {
            if (tagLoading)
              return <div className="modal-content" ref={this.scrollable} />;
            if (tagError) return `Error! ${tagError.message}`;

            const { tag } = data;

            return (
              <Mutation mutation={EDIT_TAG_MUTATION} onCompleted={closeModal}>
                {(
                  editTag,
                  { loading: editTagLoading, error: editTagError }
                ) => (
                  <Mutation
                    mutation={DELETE_TAG_MUTATION}
                    onCompleted={closeModal}
                  >
                    {(
                      deleteTag,
                      { loading: deleteTagLoading, error: deleteTagError }
                    ) => (
                      <Formik
                        initialValues={{
                          name: tag.name
                        }}
                        onSubmit={(payload, { setSubmitting }) => {
                          const { name } = payload;

                          setSubmitting(true);

                          editTag({
                            variables: {
                              id,
                              name
                            },
                            refetchQueries: () => ['tags'],
                            awaitRefetchQueries: true
                          });
                        }}
                        render={({ values, handleSubmit, isSubmitting }) => (
                          <Fragment>
                            <Query query={TAGS_QUERY}>
                              {({ loading, error, data }) => {
                                if (loading)
                                  return (
                                    <div
                                      className="modal-content"
                                      ref={this.scrollable}
                                    >
                                      Loading...
                                    </div>
                                  );
                                if (error)
                                  return (
                                    <div
                                      className="modal-content"
                                      ref={this.scrollable}
                                    >
                                      Error! {error.message}
                                    </div>
                                  );

                                return (
                                  <div
                                    className="modal-content"
                                    ref={this.scrollable}
                                  >
                                    <div className="modal-content-form">
                                      <div className="add-qa-tags">
                                        <Form>
                                          {editTagError && (
                                            <p>
                                              Error :( Please try again{' '}
                                              {JSON.stringify(editTagError)}
                                            </p>
                                          )}
                                          <Field
                                            name="name"
                                            render={({
                                              field,
                                              form: { isSubmitting }
                                            }) => (
                                              <input
                                                type="text"
                                                {...field}
                                                disabled={isSubmitting}
                                              />
                                            )}
                                          />
                                        </Form>
                                      </div>
                                    </div>
                                  </div>
                                );
                              }}
                            </Query>
                            <div className="modal-footer">
                              {isSubmitting && 'Tallennetaan...'}
                              {!isSubmitting && (
                                <button
                                  className="modal-footer-submit-delete"
                                  type="submit"
                                  onClick={this.showConfirm}
                                >
                                  Poista TAG
                                </button>
                              )}
                              {!isSubmitting && (
                                <button
                                  className="modal-footer-submit-button"
                                  type="submit"
                                  onClick={handleSubmit}
                                >
                                  Tallenna
                                </button>
                              )}
                            </div>
                            {this.state.removeConfirm && (
                              <div className="modal-confirm">
                                <div className="modal-confirm-header">
                                  <div className="modal-confirm-header-title">
                                    Muokkaa Tagia
                                  </div>
                                  <div
                                    className="modal-confirm-header-close"
                                    onClick={this.hideConfirm}
                                  >
                                    Sulje
                                  </div>
                                </div>
                                <div className="modal-confirm-body">
                                  <div className="modal-confirm-body-title">
                                    Haluatko varmasti poistaa TAG:n?
                                  </div>
                                  <div className="modal-confirm-body-actions">
                                    <div
                                      className="modal-confirm-body-action modal-confirm-body-action-borderless"
                                      onClick={this.hideConfirm}
                                    >
                                      Peruuta
                                    </div>
                                    <div
                                      className="modal-confirm-body-action"
                                      onClick={() => {
                                        deleteTag({
                                          variables: {
                                            id
                                          },
                                          refetchQueries: () => ['tags'],
                                          awaitRefetchQueries: true
                                        });
                                      }}
                                    >
                                      Poista TAG
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </Fragment>
                        )}
                      />
                    )}
                  </Mutation>
                )}
              </Mutation>
            );
          }}
        </Query>
      </Fragment>
    );
  }
}

export default EditTagModal;
